module.exports = __webpack_public_path__ + "static/media/cross.a622d8df.svg";